module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-wrap",
    attrs: {
      "id": "wrap"
    }
  }, [_c('component-header', {
    attrs: {
      "headerdata": _vm.headerdata
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "pager"
  }, [_c('div', {
    staticClass: "container card-box"
  }, [_c('div', {
    staticClass: "row card-box-o"
  }, [_c('div', {
    staticClass: "card",
    staticStyle: {
      "padding-top": "2em",
      "padding-bottom": "4em"
    },
    attrs: {
      "id": ""
    }
  }, [_c('div', {
    staticClass: "col-sm-6 col-sm-offset-1"
  }, [_c('div', {
    staticClass: "sp1-reg",
    staticStyle: {
      "background": "#ffffff",
      "padding": "2em",
      "padding-top": "0",
      "border-radius": "2px"
    }
  }, [(_vm.loading) ? _c('div', [_vm._m(0)]) : _c('div', {
    staticClass: "card"
  }, [_c('div', [(!_vm.reset_order) ? _c('div', {
    staticClass: "card"
  }, [_c('p', {
    staticClass: "text-muted"
  }, [_vm._v("Product Details")]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.product.product_name))]), _vm._v(" "), _c('p', [_vm._v("₦" + _vm._s(_vm.product_item.product_item_price_f))]), _vm._v(" "), _c('div', {
    staticClass: "category-slide"
  }, [_c('ul', _vm._l((_vm.product.product_images), function(img) {
    return _c('li', {}, [(img.product_image && (img.product_image != '' && img.product_image != 'error')) ? _c('img', {
      staticClass: "pb_img",
      attrs: {
        "src": _vm.img_product_url + img.product_image,
        "alt": ""
      }
    }) : _c('img', {
      staticClass: "pb_img",
      attrs: {
        "src": "/static/assets/images/dummy-image.png",
        "alt": ""
      }
    })])
  })), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), (_vm.product.product_images && (_vm.product.product_images.length > 1)) ? _c('div', [_c('hr'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "text-transform": "uppercase"
    }
  }, [_vm._v("Swipe to see all pictures >>")])]) : _vm._e()]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "card-box-o"
  }, [_c('h3', [_vm._v("Details")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.product.product_description))])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "btn sp-button-02",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.reset_order = true;
      }
    }
  }, [_vm._v("Reset Order")])])]) : _vm._e(), _vm._v(" "), (_vm.reset_order) ? _c('div', {
    staticClass: "card"
  }, [_c('form', {
    staticClass: "form-inline"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-xs-12"
  }, [_c('label', {}, [_vm._v("Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_name),
      expression: "product.product_name"
    }],
    staticClass: "form-control input-group-lg",
    attrs: {
      "type": "text",
      "title": "Enter  name",
      "placeholder": "Your Business Name"
    },
    domProps: {
      "value": (_vm.product.product_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-xs-12"
  }, [_c('label', {}, [_vm._v("Price")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_price),
      expression: "product.product_price"
    }],
    staticClass: "form-control input-group-lg",
    attrs: {
      "type": "number",
      "title": "Enter  name",
      "placeholder": "Your Business Name"
    },
    domProps: {
      "value": (_vm.product.product_price)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_price = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Product Photo ")]), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": "prImagePreview"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sp-form-descr"
  }, [_vm._v("Maximum Upload Size " + _vm._s(_vm.max_upload))]), _vm._v(" "), _c('div', {
    staticClass: "upload-btn-wrapper",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('button', {
    staticClass: "upload-btn",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Upload Display "), _c('span', {
    staticStyle: {
      "text-transform": "capitalize"
    }
  }, [_vm._v(_vm._s(_vm.is_product_service))]), _vm._v(" Photo")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "input-file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.onFileChangeNewProduct($event)
      }
    }
  }), _vm._v(" "), (_vm.file_info[0]) ? _c('span', [_c('b', [_vm._v("Added " + _vm._s(_vm.file_info[0].name))])]) : _vm._e()]), _vm._v(" "), _vm._m(1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-xs-12"
  }, [_c('label', {}, [_vm._v("Details")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_description),
      expression: "product.product_description"
    }],
    staticClass: "form-control input-group-lg",
    attrs: {
      "type": "text",
      "title": "Enter  name",
      "placeholder": "Your Business Name"
    },
    domProps: {
      "value": (_vm.product.product_description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_description = $event.target.value
      }
    }
  })])]), _vm._v(" "), (Object.keys(_vm.sellpoint).length == 0) ? _c('div', [_c('h3', [_vm._v("Contact Details")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-xs-12"
  }, [_c('label', {}, [_vm._v("Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sellpoint.business_name),
      expression: "sellpoint.business_name"
    }],
    staticClass: "form-control input-group-lg",
    attrs: {
      "type": "text",
      "title": "Enter  name",
      "placeholder": "Your Name"
    },
    domProps: {
      "value": (_vm.sellpoint.business_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sellpoint.business_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-12"
  }, [_c('label', {}, [_vm._v("Phone Number")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sellpoint.business_phone),
      expression: "sellpoint.business_phone"
    }],
    staticClass: "form-control input-group-lg",
    attrs: {
      "type": "text",
      "title": "Enter  name",
      "placeholder": "Your Name"
    },
    domProps: {
      "value": (_vm.sellpoint.business_phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sellpoint.business_phone = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-12"
  }, [_c('label', {}, [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sellpoint.business_email),
      expression: "sellpoint.business_email"
    }],
    staticClass: "form-control input-group-lg",
    attrs: {
      "type": "text",
      "title": "Enter  name",
      "placeholder": "Your Name"
    },
    domProps: {
      "value": (_vm.sellpoint.business_email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sellpoint.business_email = $event.target.value
      }
    }
  })])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('h3', [_vm._v("Order Addons")]), _vm._v(" "), _c('p', [_vm._v("Add Items that could be ordered together with this Order")]), _vm._v(" "), ((Object.keys(_vm.products).length > 0)) ? _c('div', {
    staticClass: "row"
  }, [_vm._l((_vm.products), function(product, index) {
    return _c('div', {
      staticClass: "card col-xs-4"
    }, [_c('a', {
      staticClass: "card-link",
      staticStyle: {
        "text-decoration": "none",
        "color": "inherit"
      },
      attrs: {
        "href": '/' + _vm.user.business_username
      }
    }, [_c('div', {
      staticClass: "card",
      staticStyle: {
        "margin-bottom": "1em"
      }
    }, [_c('div', {
      staticClass: "card-avatar-square",
      staticStyle: {
        "width": "100px",
        "height": "95px"
      }
    }, [(product.product_images[0]) ? _c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": product.product_images[0].product_image
      }
    }) : _c('img', {
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "card-col-details",
      staticStyle: {
        "display": "block",
        "padding": "3px",
        "padding-left": "2em",
        "text-align": "center"
      }
    }, [_c('p', {
      staticClass: "prd-name",
      staticStyle: {
        "font-size": "16px"
      }
    }, [_vm._v(_vm._s(product.product_name) + " "), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "sm-x"
    }, [_vm._v("₦‎" + _vm._s(product.product_items[0].product_item_price_f))])]), _vm._v(" "), _c('input', {
      attrs: {
        "type": "checkbox"
      },
      on: {
        "click": function($event) {
          _vm.setAddToProductAddons(product)
        }
      }
    })])])])])
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "5px",
      "display": "none"
    }
  }, [_c('button', {
    staticClass: "btn sp-button-sm",
    staticStyle: {
      "float": "right",
      "background": "#ff0066",
      "color": "#ffffff"
    },
    on: {
      "click": function($event) {
        _vm.addToProductAddons()
      }
    }
  }, [_vm._v("Done, Add Products to Add-ons")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])], 2) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('h3', [_vm._v("Settings")]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "text-align": "center",
      "padding-top": "0.2em"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('bankDetails')
      }
    }
  }, [_vm._m(2)]), _vm._v(" "), (_vm.menu_tab_inner_view['bankDetails']) ? _c('div', {
    attrs: {
      "id": "bankDetails"
    }
  }, [_c('div', {
    staticClass: "card card-colord-01 card-colord-pad"
  }, [_vm._m(3), _vm._v(" "), _c('p', {
    staticClass: "p-tiny-info"
  }, [_vm._v("Add your Bank Details to receive order payments")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', [_c('a', {
    staticClass: "btn sp-button-02 sp-button-sm",
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('')
      }
    }
  }, [_vm._v("close")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', [((!_vm.setEditBankDetails && (Object.keys(_vm.business_bank_details).length > 0))) ? _c('div', [_c('p', [_c('b', [_vm._v("Bank:")]), _vm._v(" " + _vm._s(_vm.business_bank_details.bank_name))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Account Holder's Name:")]), _vm._v(" " + _vm._s(_vm.business_bank_details.bank_account_name))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Account No:")]), _vm._v(" " + _vm._s(_vm.business_bank_details.bank_account_number))]), _vm._v(" "), _c('p', {
    staticClass: "tiny-p"
  }, [_vm._v("you can edit or change bank details")]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setEditBankDetails = true;
      }
    }
  }, [_vm._v("Edit Bank Details")])]) : _vm._e(), _vm._v(" "), (((Object.keys(_vm.business_bank_details).length == 0) || _vm.setEditBankDetails)) ? _c('form', {
    staticClass: "sp-form",
    staticStyle: {
      "padding-left": "0"
    }
  }, [(_vm.ravepay_bank_list && ((Object.keys(_vm.ravepay_bank_list).length == 0))) ? _c('div', [_vm._m(4)]) : _c('div', [_c('label', [_c('b', [_vm._v("Bank Name:")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business_bank_details.bank_name),
      expression: "business_bank_details.bank_name"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.business_bank_details.bank_name = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select your bank")]), _vm._v(" "), _vm._l((_vm.ravepay_bank_list), function(bank) {
    return _c('option', {
      domProps: {
        "value": bank.Name
      }
    }, [_vm._v(_vm._s(bank.Name))])
  })], 2)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', [_c('b', [_vm._v("Account Name:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business_bank_details.bank_account_name),
      expression: "business_bank_details.bank_account_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.business_bank_details.bank_account_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.business_bank_details.bank_account_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', [_c('b', [_vm._v("Account No:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business_bank_details.bank_account_number),
      expression: "business_bank_details.bank_account_number"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.business_bank_details.bank_account_number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.business_bank_details.bank_account_number = $event.target.value
      }
    }
  })]), _vm._v(" "), ((Object.keys(_vm.sellpoint).length > 0)) ? _c('div', [_c('p', {
    staticClass: "tiny-p"
  }), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    attrs: {
      "disabled": _vm.disable_btn,
      "type": "button"
    },
    on: {
      "click": _vm.setBankDetails
    }
  }, [_vm._v("Save Bank Details")])]) : _vm._e()])]) : _vm._e()])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "text-align": "center",
      "padding-top": "0.2em"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('deliveryLocations')
      }
    }
  }, [_vm._m(5)]), _vm._v(" "), (_vm.menu_tab_inner_view['deliveryLocations']) ? _c('div', {
    attrs: {
      "id": "deliveryLocations"
    }
  }, [((!_vm.setAddDeliveryLocation && (Object.keys(_vm.business_delivery_locations).length > 0))) ? _c('div', [_c('h3', [_vm._v("Delivery Locations")]), _vm._v(" "), _vm._l((_vm.business_delivery_locations), function(location, index) {
    return _c('div', [_c('p', [_vm._v(_vm._s(++index) + " - " + _vm._s(location.business_delivery_state) + " - " + _vm._s(location.business_delivery_option) + " - " + _vm._s(location.business_delivery_option_price) + "\r\n                                    "), _c('br'), _vm._v(" "), _c('span', [_c('a', {
      staticClass: "card-link",
      on: {
        "click": function($event) {
          _vm.toggleSingleComponent('DL-CHANGE-PRICE-' + index)
        }
      }
    }, [_vm._v("Change Price")]), _vm._v("  | \r\n                                      "), _c('a', {
      staticClass: "card-link",
      on: {
        "click": function($event) {
          _vm.toggleSingleComponent('DL-REMOVE-' + index)
        }
      }
    }, [_vm._v("Remove")])])]), _vm._v(" "), _c('div', {
      staticClass: "card-box",
      staticStyle: {
        "display": "none"
      },
      attrs: {
        "id": 'DL-CHANGE-PRICE-' + index
      }
    }, [_c('p', [_c('b', [_vm._v("Current Price: ")]), _vm._v(_vm._s(location.business_delivery_option_price))]), _vm._v(" "), _c('div', {
      staticClass: "form-group"
    }, [_c('label', [_vm._v("Delivery Price")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (location.business_delivery_option_price),
        expression: "location.business_delivery_option_price"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "number",
        "required": ""
      },
      domProps: {
        "value": (location.business_delivery_option_price)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          location.business_delivery_option_price = $event.target.value
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "form-group"
    }, [(_vm.action_loading) ? _c('div', {
      staticClass: "loading-sm"
    }) : _vm._e(), _vm._v(" "), _c('p', {
      staticStyle: {
        "color": "#ff0000"
      }
    }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('button', {
      staticClass: "btn sp-button-02",
      staticStyle: {
        "line-height": "1.6",
        "padding": "10px"
      },
      attrs: {
        "disabled": _vm.disable_btn,
        "title": "save",
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.delivery_option = location;
          _vm.set_single_component_view = 'DL-CHANGE-PRICE-' + index;
          _vm.editDeliveryOption();
        }
      }
    }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
      staticClass: "btn sp-button-02",
      staticStyle: {
        "line-height": "1.6",
        "padding": "10px"
      },
      attrs: {
        "title": "cancel",
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('reset-edit', '')
        }
      }
    }, [_vm._v("Cancel")])])]), _vm._v(" "), _c('div', {
      staticClass: "card-box",
      staticStyle: {
        "display": "none"
      },
      attrs: {
        "id": 'DL-REMOVE-' + index
      }
    }, [_c('p', {
      staticStyle: {
        "color": "#ff0000"
      }
    }, [_vm._v("Do you want to delete this location.")]), _vm._v(" "), _c('div', {
      staticClass: "form-group"
    }, [(_vm.action_loading) ? _c('div', {
      staticClass: "loading-sm"
    }) : _vm._e(), _vm._v(" "), _c('p', {
      staticStyle: {
        "color": "#ff0000"
      }
    }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('button', {
      staticClass: "btn sp-button-02",
      staticStyle: {
        "line-height": "1.6",
        "padding": "10px"
      },
      attrs: {
        "disabled": _vm.disable_btn,
        "title": "save",
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.delivery_option = location;
          _vm.set_single_component_view = 'DL-REMOVE-' + index;
          _vm.deleteDeliveryOption(location.business_delivery_option_id);
        }
      }
    }, [_vm._v("Yes")]), _vm._v(" "), _c('button', {
      staticClass: "btn sp-button-02",
      staticStyle: {
        "line-height": "1.6",
        "padding": "10px"
      },
      attrs: {
        "title": "cancel",
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('reset-edit', '')
        }
      }
    }, [_vm._v("Cancel")])])]), _vm._v(" "), _c('div'), _vm._v(" "), _c('hr')])
  }), _vm._v(" "), _c('button', {
    staticClass: "btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setAddDeliveryLocation = true;
      }
    }
  }, [_vm._v("Add Delivery Locations")])], 2) : _vm._e(), _vm._v(" "), (((Object.keys(_vm.business_delivery_locations).length == 0) || _vm.setAddDeliveryLocation)) ? _c('div', {
    key: _vm.componentDeliveryKey,
    staticClass: "card"
  }, [_c('h5', [_vm._v("Add a Delivery Location and Price")]), _vm._v(" "), (_vm.states && (Object.keys(_vm.states).length == 0)) ? _c('div', [_vm._m(6)]) : _c('div', [_c('div', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("State")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.delivery_option.state),
      expression: "delivery_option.state"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.delivery_option.state = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.getCities(_vm.delivery_option.state, '')
      }]
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select State")]), _vm._v(" "), _vm._l((_vm.states), function(state) {
    return _c('option', {
      key: state.state_id,
      domProps: {
        "value": state.state_id
      }
    }, [_vm._v(_vm._s(state.name))])
  })], 2)]), _vm._v(" "), (_vm.action_loading) ? _c('div', [_c('p', [_vm._v("...loading cities")])]) : _vm._e(), _vm._v(" "), (_vm.cities.length && _vm.cities.length != 0 && !_vm.edit_city) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("City")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.delivery_option.city),
      expression: "delivery_option.city"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.delivery_option.city = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.setOtherOptions(_vm.delivery_option.city, '')
      }]
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select City")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "all"
    }
  }, [_vm._v("All Areas @Fixed Price")]), _vm._v(" "), _vm._l((_vm.cities), function(city) {
    return _c('option', {
      key: city.city_id,
      domProps: {
        "value": city.city_id
      }
    }, [_vm._v(_vm._s(city.city_name))])
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "other"
    }
  }, [_vm._v("Other Areas / Cities ")])], 2)]) : _vm._e(), _vm._v(" "), (_vm.other_delivery_option) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Other Areas / Cities")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.delivery_option.delivery_other_option),
      expression: "delivery_option.delivery_other_option"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "eg. Abuja"
    },
    domProps: {
      "value": (_vm.delivery_option.delivery_other_option)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.delivery_option.delivery_other_option = $event.target.value
      }
    }
  }), _c('br')]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Free Delivery?")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.delivery_option.delivery_option_free),
      expression: "delivery_option.delivery_option_free"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.delivery_option.delivery_option_free) ? _vm._i(_vm.delivery_option.delivery_option_free, null) > -1 : (_vm.delivery_option.delivery_option_free)
    },
    on: {
      "click": function($event) {
        _vm.setFreeDelivery(1)
      },
      "__c": function($event) {
        var $$a = _vm.delivery_option.delivery_option_free,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.delivery_option.delivery_option_free = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.delivery_option.delivery_option_free = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.delivery_option.delivery_option_free = $$c
        }
      }
    }
  })]), _vm._v(" "), (_vm.delivery_option.delivery_option_free != 1) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Delivery Charge")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.delivery_option.delivery_option_price),
      expression: "delivery_option.delivery_option_price"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "placeholder": "eg. 1000"
    },
    domProps: {
      "value": (_vm.delivery_option.delivery_option_price)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.delivery_option.delivery_option_price = $event.target.value
      }
    }
  }), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), (((Object.keys(_vm.sellpoint).length > 0) && (_vm.sellpoint.business_id > 0))) ? _c('button', {
    staticClass: "btn sp-button-02 sp-button-md",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.addDeliveryOption()
      }
    }
  }, [_vm._v("Add")]) : _c('button', {
    staticClass: "btn sp-button-02 sp-button-md",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setAddDeliveryOptions(_vm.delivery_option)
      }
    }
  }, [_vm._v("Add")]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-02 sp-button-md",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setAddDeliveryLocation = false;
        _vm.setMenuTabInnerView('')
      }
    }
  }, [_vm._v("Cancel")])])]) : _vm._e()]) : _vm._e()])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_error_message))]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#43a1fa"
    }
  }, [_vm._v(_vm._s(_vm.data_boarding_message))]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-1",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.createOrder
    }
  }, [_vm._v("Create")])]) : _vm._e()])])])])])])])]), _vm._v(" "), _c('component-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', {
    staticClass: "sp-form-descr"
  }, [_vm._v("(You can always add more images or video on this post)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "background": "#fff",
      "border-radius": "5px",
      "padding": "10px",
      "margin": "5px 35vw",
      "box-shadow": "0 7px 30px -10px rgba(150,170,180,0.5)"
    }
  }, [_vm._v("Manage "), _c('i', {
    staticClass: "fa fa-angle-down",
    staticStyle: {
      "font-size": "18px"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Bank Information")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "background": "#fff",
      "border-radius": "5px",
      "padding": "10px",
      "margin": "5px 35vw",
      "box-shadow": "0 7px 30px -10px rgba(150,170,180,0.5)"
    }
  }, [_vm._v("Manage "), _c('i', {
    staticClass: "fa fa-angle-down",
    staticStyle: {
      "font-size": "18px"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-13ee02b4"}!./src/pages/Settings/template.html
// module id = 504
// module chunks = 0